<!--
Copyright (c) 2026 Wind River Systems, Inc.

The right to copy, distribute, modify, or otherwise make use of this software may be licensed only pursuant to the terms of an applicable Wind River license agreement.
-->
<mat-form-field>
  <mat-select [(ngModel)]="selected" (selectionChange)="onSelect($event.value)" [required]="selectRequired">
    <mat-form-field appearance="fill" class="w-100 dropdown-search">
      <input matInput type="text" [(ngModel)]="searchValue" placeholder="Search..." class="w-100" autocomplete="off" />
      <mat-icon matSuffix aria-label="search icon">search</mat-icon>
    </mat-form-field>
    <mat-option
      *ngFor="let item of filteredItems"
      [value]="item"
      [matTooltip]="getTooltip(item)"
      [matTooltipShowDelay]="1000"
    >
      {{ searchProperty ? item[searchProperty] : item }}
    </mat-option>
  </mat-select>
  <mat-hint *ngIf="hint">{{ hint }}</mat-hint>
</mat-form-field>
